export enum MachinePreferencesLocalStorageKey {
  MACHINE_ID = 'machineId',
  CALL_CENTER_CODE = 'callCenterCode',
  STATION_NUMBER = 'stationNumber',
}
